<div class="d-flex flex-column min-vh-100">
    <app-default-header class="mb-4 d-print-none header header-sticky" position="sticky" sidebarId="sidebar" />
    <c-sidebar #sidebar="cSidebar" class="d-print-none sidebar sidebar-fixed" id="sidebar" visible>
        <ng-scrollbar pointerEventsMethod="scrollbar">
            <c-sidebar-nav [navItems]="navItems()" dropdownMode="close" />
        </ng-scrollbar>
        @if (!sidebar.narrow) {
        <c-sidebar-toggler cSidebarToggle="sidebar" toggle="unfoldable" />
        }
    </c-sidebar>
    <div class="wrapper pb-4">
        <div class="body flex-grow-1" [class.px-4]="!fullScreen()">
            <router-outlet />
        </div>
        <!-- <app-default-footer /> -->
    </div>
    @if (isRootAdmin() && !rootBannerDismissed()) {
        <div class="root-admin-banner d-print-none">
            <svg cIcon name="cilWarning" size="sm" class="flex-shrink-0"></svg>
            <span>You are operating as <strong>Root Admin</strong> — a highly privileged role. Be mindful of the impact your actions may have across the entire system.</span>
            <button type="button" class="root-admin-banner-close ms-auto" (click)="rootBannerDismissed.set(true)" aria-label="Dismiss">
                <svg cIcon name="cilX" size="sm"></svg>
            </button>
        </div>
    }
</div>